module.exports = __webpack_public_path__ + "static/media/twitter_logo.35166d47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/twitter_logo.svg
// module id = 1226
// module chunks = 0